// extracted by mini-css-extract-plugin
export default {"button":"Button_button__CpODN","red":"Button_red__yLUdf","blue":"Button_blue__TZKb9"};